import React from 'react';
import { MessageCircle } from 'lucide-react';
import { getCategory } from './chatCategories';

export const SessionList = ({ sessions, activeId, onSelect, emptyLabel, language }) => {
  if (!sessions.length) {
    return <p className="px-2 py-4 text-sm text-muted-foreground" data-testid="chat-sessions-empty">{emptyLabel}</p>;
  }
  return sessions.map((s) => {
    const cat = getCategory(s.category);
    const isActive = activeId === s.session_id;
    return (
      <button
        key={s.session_id}
        type="button"
        onClick={() => onSelect(s)}
        data-testid={`chat-session-${s.session_id}`}
        className={`mb-2 w-full rounded-xl border p-3 text-left transition-colors duration-200 ${
          isActive ? 'border-primary/30 bg-primary/10 shadow-sm' : 'border-transparent hover:bg-muted/50'
        }`}
      >
        <div className="flex items-start gap-3">
          <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${isActive ? 'bg-primary/20' : 'bg-muted'}`}>
            <MessageCircle className={`h-4 w-4 ${isActive ? 'text-primary' : 'text-muted-foreground'}`} />
          </div>
          <div className="min-w-0 flex-1">
            <span className="line-clamp-2 text-sm text-foreground">{s.first_question}</span>
            <span className="mt-1 block text-xs text-muted-foreground">
              {language === 'sw' ? cat.sw : cat.en} · {new Date(s.last_timestamp).toLocaleDateString()}
            </span>
          </div>
        </div>
      </button>
    );
  });
};
